import { useState, useEffect } from 'react';
import { Socket } from 'socket.io-client';
import toast from 'react-hot-toast';

interface VideoPanelProps {
  sessionId: string;
  socket: Socket | null;
  isConnected: boolean;
}

interface VideoFile {
  name: string;
  filename: string;
  url: string;
}

export function VideoPanel({ sessionId, socket, isConnected }: VideoPanelProps) {
  const [videos, setVideos] = useState<VideoFile[]>([]);
  const [selectedVideo, setSelectedVideo] = useState<string | null>('black');

  useEffect(() => {
    fetch('/api/videos')
      .then((res) => res.json())
      .then((data) => setVideos(data.videos || []))
      .catch((err) => {
        console.error('Error loading videos:', err);
        toast.error('Errore caricamento video');
      });
  }, []);

  const handleSelectBlack = () => {
    if (!socket || !isConnected) {
      toast.error('Socket non connesso');
      return;
    }

    setSelectedVideo('black');
    socket.emit('admin:set-projection', {
      sessionId,
      mode: { type: 'backdrop', url: 'black' },
    });
    toast.success('Schermo nero attivato');
  };

  const handleSelectVideo = (video: VideoFile) => {
    if (!socket || !isConnected) {
      toast.error('Socket non connesso');
      return;
    }

    setSelectedVideo(video.url);
    socket.emit('admin:set-projection', {
      sessionId,
      mode: { type: 'video', url: video.url },
    });
    toast.success(`Video "${video.name}" avviato`);
  };

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
      <h3 className="text-xl font-bold text-white mb-4">Video</h3>

      {/* Pulsante Nero */}
      <div className="mb-6">
        <button
          onClick={handleSelectBlack}
          className={`w-full py-4 rounded-lg font-bold text-lg transition-all ${
            selectedVideo === 'black'
              ? 'bg-gray-900 text-white ring-4 ring-purple-500 shadow-lg shadow-purple-500/30'
              : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
          }`}
        >
          Nero
        </button>
      </div>

      {/* Lista video */}
      {videos.length > 0 ? (
        <div className="flex flex-wrap gap-4">
          {videos.map((video) => (
            <button
              key={video.url}
              onClick={() => handleSelectVideo(video)}
              className={`px-6 py-4 rounded-lg font-semibold transition-all ${
                selectedVideo === video.url
                  ? 'bg-purple-600 text-white ring-4 ring-purple-500 shadow-lg shadow-purple-500/30'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              }`}
            >
              {video.name}
            </button>
          ))}
        </div>
      ) : (
        <p className="text-gray-400 text-center py-8">
          Nessun video disponibile. Aggiungi file <code className="bg-gray-700 px-2 py-1 rounded">.mp4</code> o <code className="bg-gray-700 px-2 py-1 rounded">.webm</code> nella cartella <code className="bg-gray-700 px-2 py-1 rounded">video/</code>
        </p>
      )}

      {!isConnected && (
        <div className="mt-4 p-3 bg-yellow-900/30 border border-yellow-600 rounded-lg">
          <p className="text-yellow-300 text-sm">
            Socket non connesso. I video non possono essere proiettati.
          </p>
        </div>
      )}
    </div>
  );
}
